import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
import { textEllipsis } from '@finect/tabular-utils/textEllipsis';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
export var Inner = styled.div.withConfig({
  displayName: "partials__Inner",
  componentId: "sc-1jjfc3v-0"
})(["min-height:300px;padding:7px 9px;margin:20px auto 16px;"]);
export var Title = styled.div.withConfig({
  displayName: "partials__Title",
  componentId: "sc-1jjfc3v-1"
})(["margin-bottom:32px;text-align:center;"]);
export var TitleLeft = styled.div.withConfig({
  displayName: "partials__TitleLeft",
  componentId: "sc-1jjfc3v-2"
})(["text-align:left;margin-bottom:32px;padding-bottom:8px;width:100%;border-bottom:2px solid ", ";display:flex;align-items:center;justify-content:space-between;h4{", " font-weight:400;}", ""], function (_ref) {
  var theme = _ref.theme;
  return theme.plus.greyD;
}, getFont(3), maxMediaQueries.phablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    align-items: flex-start;\n    \n    h4 {\n      ", "\n    }\n  "])), getFont(1)));
export var ButtonsContainer = styled.div.withConfig({
  displayName: "partials__ButtonsContainer",
  componentId: "sc-1jjfc3v-3"
})(["display:flex;align-items:center;justify-content:center;gap:8px;"]);
var ContentSize = {
  small: '320px',
  large: '100%'
};
export var Content = styled.div.withConfig({
  displayName: "partials__Content",
  componentId: "sc-1jjfc3v-4"
})(["overflow-y:auto;", ""], function (_ref2) {
  var size = _ref2.size;
  return "max-height: ".concat(ContentSize[size], ";");
});
export var GraphContent = styled.div.withConfig({
  displayName: "partials__GraphContent",
  componentId: "sc-1jjfc3v-5"
})(["> div:first-child{display:grid;grid-template-columns:1fr 1fr;grid-gap:24px;margin-bottom:64px;> div{box-shadow:0px 4px 50px -5px rgba(0,0,0,0.1);padding:24px 13px 16px;border-radius:8px;min-height:510px;", " ", "}", "}"], maxMediaQueries.desktop(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["min-height: 400px;"]))), maxMediaQueries.phablet(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["min-height: 400px;"]))), maxMediaQueries.phablet(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      grid-template-columns: 1fr;\n      grid-gap: 16px;\n      margin-bottom: 32px;\n  "]))));
export var FundNamesContainer = styled.div.withConfig({
  displayName: "partials__FundNamesContainer",
  componentId: "sc-1jjfc3v-6"
})(["display:grid;grid-template-columns:repeat(", ",minmax(0,1fr));grid-gap:16px;margin-bottom:24px;padding:0 8px;> div{border-radius:8px;border:1.5px solid ", ";}", ""], function (_ref3) {
  var columns = _ref3.columns;
  return columns;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.plus.greyD;
}, maxMediaQueries.phablet(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  "]))));
export var FundNameBlock = styled.div.withConfig({
  displayName: "partials__FundNameBlock",
  componentId: "sc-1jjfc3v-7"
})(["display:flex;align-items:center;padding:8px;min-height:40px;> span{margin-right:8px;}div{display:flex;flex-direction:column;", ";", " font-weight:400;line-height:1.2;p{color:", ";margin:0;}span{color:", ";}}"], textEllipsis, function (_ref5) {
  var _ref5$fontSize = _ref5.fontSize,
    fontSize = _ref5$fontSize === void 0 ? -1 : _ref5$fontSize;
  return getFont(fontSize);
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.plus.fontDD;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.plus.fontD;
});
export var CuteContent = styled.div.withConfig({
  displayName: "partials__CuteContent",
  componentId: "sc-1jjfc3v-8"
})([".separator{height:100%;padding:0 16px;align-self:center;align-content:center;color:", ";font-weight:400;}> div{border-radius:8px;border:1.5px solid ", ";margin-bottom:20px;display:grid;grid-template-columns:1fr 200px 150px;overflow:hidden;", "}> div > div:first-child{height:fit-content;padding:6px 8px;display:flex;flex-direction:row;flex-wrap:wrap;> div{width:250px;overflow:hidden;}", "}> div > div:nth-child(2){display:flex;align-items:center;", "}> div > div:nth-child(3){display:flex;align-items:center;justify-content:space-evenly;> span{cursor:pointer;}", "}"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.plus.font;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.plus.greyD;
}, maxMediaQueries.phablet(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n      grid-template-columns: 1fr;\n      grid-template-rows: auto auto auto;\n      gap: 12px;\n    "]))), maxMediaQueries.phablet(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n      flex-direction: column;\n      align-items: center;\n      width: 100%;\n      overflow: hidden;\n    "]))), maxMediaQueries.phablet(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n      margin-bottom: 12px;\n      align-items: flex-start;\n      justify-content: center;\n    "]))), maxMediaQueries.phablet(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n      background-color: ", ";\n      padding-top: 8px;\n    "])), function (_ref10) {
  var theme = _ref10.theme;
  return theme.plus.grey;
}));
export var EmptyContentInner = styled.div.withConfig({
  displayName: "partials__EmptyContentInner",
  componentId: "sc-1jjfc3v-9"
})(["color:", ";text-align:center;svg{margin:36px auto 42px;}p{margin:0 auto;}"], function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.fontL;
});
export var ViewMoreButton = styled.button.withConfig({
  displayName: "partials__ViewMoreButton",
  componentId: "sc-1jjfc3v-10"
})(["display:block;padding:4px 50px;margin-top:42px;border-radius:50px;background-color:transparent;color:", ";", " font-weight:400;border:1.5px solid ", ";cursor:pointer;transition:background-color 0.3s ease;&:hover:not(:disabled){background-color:", ";color:", ";border-color:", ";}&:disabled{background-color:", ";opacity:0.5;cursor:not-allowed;}"], function (_ref12) {
  var theme = _ref12.theme;
  return theme.plus.fontD;
}, getFont(0), function (_ref13) {
  var theme = _ref13.theme;
  return theme.plus.fontD;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.plus.grey;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.plus.fontDD;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.plus.fontDD;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.plus.grey;
});
export var ButtonContainer = styled.div.withConfig({
  displayName: "partials__ButtonContainer",
  componentId: "sc-1jjfc3v-11"
})(["display:flex;justify-content:center;margin-top:24px;"]);